export { StrongCache } from "./strong.js";
export { WeakCache } from "./weak.js";
//# sourceMappingURL=index.js.map